import { useState } from 'react'
import { UserModel } from '../../models/user.model'
import CommonModal from '../Modal/Modal'
import Login from './Login/Login'
import Signup from './Signup/Signup'
import style from './phone-verification.module.scss'

export interface PhoneVerificationProps {
  isOpen: boolean
  onClose: () => void
  onSuccess?: (user: UserModel) => void
  defaultMode?: 'login' | 'signup'
}

enum AuthMode {
  LOGIN = 'LOGIN',
  SIGNUP = 'SIGNUP',
}

/**
 * PhoneVerification - Main authentication component
 * Provides both Login and Signup functionality with toggle
 */
const PhoneVerification = ({
  isOpen,
  onClose,
  onSuccess,
  defaultMode = 'login',
}: PhoneVerificationProps) => {
  const [authMode, setAuthMode] = useState<AuthMode>(
    defaultMode === 'login' ? AuthMode.LOGIN : AuthMode.SIGNUP
  )

  const handleClose = () => {
    setAuthMode(defaultMode === 'login' ? AuthMode.LOGIN : AuthMode.SIGNUP)
    onClose()
  }

  const handleSuccess = () => {
    setAuthMode(defaultMode === 'login' ? AuthMode.LOGIN : AuthMode.SIGNUP)
    onSuccess?.(undefined as any) // User data is already in store after auth
    onClose?.()
  }

  if (!isOpen) {
    return null
  }

  return (
    <CommonModal
      modalWidth={'500px'}
      open={isOpen}
      title={authMode === AuthMode.LOGIN ? 'Login' : 'Sign Up'}
      onCloseModal={handleClose}
    >
      <>
        <div className={style.authModeToggle}>
          <button
            type="button"
            className={authMode === AuthMode.LOGIN ? style.activeMode : ''}
            onClick={() => setAuthMode(AuthMode.LOGIN)}
          >
            Login
          </button>
          <button
            type="button"
            className={authMode === AuthMode.SIGNUP ? style.activeMode : ''}
            onClick={() => setAuthMode(AuthMode.SIGNUP)}
          >
            Sign Up
          </button>
        </div>

        {authMode === AuthMode.LOGIN ? (
          <Login onSuccess={handleSuccess} onSwitchToSignup={() => setAuthMode(AuthMode.SIGNUP)} />
        ) : (
          <Signup onSuccess={handleSuccess} onSwitchToLogin={() => setAuthMode(AuthMode.LOGIN)} />
        )}
      </>
    </CommonModal>
  )
}

export default PhoneVerification
